var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpactAssessment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 45,
    viewBox: "0 0 57 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000305176,
    y: 7.44717,
    width: 9.10232,
    height: 37.5126,
    fill: "#BFA1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7222,
    y: 0.0000305176,
    width: 9.10232,
    height: 44.9599,
    fill: "#BFA1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4444,
    y: 6.34396,
    width: 9.10232,
    height: 38.6159,
    fill: "#BFA1FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1665,
    y: 14.8945,
    width: 9.10232,
    height: 30.0652,
    fill: "#BFA1FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000305176,
    y: 12.1367,
    width: 9.10232,
    height: 32.8235,
    fill: "#834FF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7222,
    y: 22.6183,
    width: 9.10232,
    height: 22.3421,
    fill: "#834FF1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4444,
    y: 14.3434,
    width: 9.10232,
    height: 30.6169,
    fill: "#834FF1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1665,
    y: 35.5817,
    width: 9.10232,
    height: 9.37815,
    fill: "#834FF1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000305176,
    y: 28.1346,
    width: 9.10232,
    height: 16.8255,
    fill: "#3D00C1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7222,
    y: 35.5817,
    width: 9.10232,
    height: 9.37815,
    fill: "#3D00C1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4444,
    y: 28.1346,
    width: 9.10232,
    height: 16.8255,
    fill: "#3D00C1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1665,
    y: 38.8916,
    width: 9.10232,
    height: 6.06821,
    fill: "#3D00C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactAssessment);
export default __webpack_public_path__ + "static/media/Impact_assessment.9440c419b86ee41e8e4cf01d345ee68d.svg";
export { ForwardRef as ReactComponent };